<template>
  <div class="main">
    <main>
      <div style="margin-top: 15px;width: 547px;">
        <el-input placeholder="请输入专业名称" v-model="input">
          <el-button slot="append" icon="el-icon-search" @click="search()">搜索</el-button>
        </el-input>
      </div>
      <div class="tabchange">
        <span :class="current==1?'active':''" @click="handleClick(1)">本科</span>
        <span :class="current==2?'active':''" @click="handleClick(2)">专科</span>
        <span :class="current==3?'active':''" @click="handleClick(3)">职业本科</span>
      </div>
      <div class="main1 flex">
        <div class="left">
          <div class="tabs flex">
            <div class="list">
              <p :class="no==index?'active':''" v-for="(item,index) in data" @click="change(index)">{{item.name}}</p>

            </div>
          </div>
        </div>
        <div class="right" v-show="search_data.length==0">
          <div class="zhuanye_one">
            <div class="tabs">
              <span v-for="(item1,index) in data[no].childrenNode" :class="activeNo==index?'active':zhuanye_name"
                @click="tabchange(item1,index)">{{item1.name}}</span>
            </div>
            <div class="schoolList">
              <div class="one flex" v-for="(item,index) in special">
                <div class="info">
                  <div><span class="name">{{item.major_name}}</span></div>
                  <div class="type">
                    <span>专业代码:{{item.major_code}}</span>
                    <span>修业年限:{{item.year}}</span>
                    <span>授予学位门类:{{item.major_type}}</span>
                  </div>
                </div>

                <button type="button" @click="goDetail(item)" v-show="has_detail==1">查看详情</button>
                <button type="button" style="background-color: #9b9191;" v-show="has_detail==0">查看详情</button>
              </div>
            </div>
          </div>
        </div>

        <div class="right" v-show="search_data.length!=0">
          <div class="zhuanye_one">
            <div class="schoolList">
              <div class="one flex" v-for="(item,index) in search_data">
                <div class="info">
                  <div><span class="name">{{item.major_name}}</span></div>
                  <div class="type">
                    <span>专业代码:{{item.major_code}}</span>
                    <span>修业年限:{{item.year}}</span>
                    <span>授予学位门类:{{item.major_type}}</span>
                  </div>
                </div>
                <button type="button" @click="goDetail(item)" v-show="has_detail==1">查看详情</button>
                <button type="button" style="background-color: #9b9191;" v-show="has_detail==0">查看详情</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: "first",
        input: '',
        activeNo: 0,
        data: [],
        no: 0,
        no1: 0,
        current: 1,
        special: [],
        type_id: 34,
        type_list: [],
        search_data: [],
        has_detail: 1
      }
    },
    created() {
      this.$http.majorTypeList().then(res => {
        this.data = res.data.list
        this.$http.majorList({
          type_id: this.type_id
        }).then(res => {
          this.special = res.data.list
          this.type_list = res.data.type_list
          this.has_detail = res.data.has_detail
        })
      })
    },
    methods: {
      search() {
        this.$http.majorSearch({
          name: this.input,
          level: this.current
        }).then(res => {
          this.search_data = res.data.major_list
        })
        console.log(this.input)
      },
      tabchange(item, index) {
        this.activeNo = index
        console.log(item)
        this.$http.majorList({
          type_id: item.id
        }).then(res => {
          this.special = res.data.list
          this.has_detail = res.data.has_detail
        })
      },
      handleClick(index) {
        this.current = index
        this.search_data = []
        this.special = []
        this.$http.majorTypeList({
          level: this.current
        }).then(res => {
          this.data = res.data.list
          this.$http.majorList({
            type_id: this.data[index].childrenNode[0].id
          }).then(res => {
            console.log(res.data.list)
            this.special = res.data.list
            this.has_detail = res.data.has_detail
          })
        })
      },
      change(index) {
        this.no = index
        this.activeNo = 0
        this.search_data = []
        this.type_id = this.data[index].childrenNode[0].id
        this.$http.majorList({
          type_id: this.type_id
        }).then(res => {
          this.special = res.data.list
          this.has_detail = res.data.has_detail
        })
      },
      goDetail(item) {
        this.$router.push('/specialtyDetail?id=' + item.major_code)
      }
    }
  }
</script>

<style scoped lang="scss">
  $color: #C10B17;

  .right {
    width: 800px;
    margin-left: 31px;
  }

  .title {
    width: 100%;
    text-align: left;
    text-indent: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #343434;
    border-bottom: 1px solid #EEEEEE;
    padding-bottom: 20px;
  }

  .left {
    width: 267px;

    .list {
      // height: 555px;
      background: #FFFFFF;
      border: 1px solid #EDEDED;

      p {
        width: 255px;
        height: 45px;
        line-height: 45px;
        text-align: left;
        text-indent: 14px;
      }

      .active {
        background: $color;
        color: #FFFFFF;
      }
    }

  }

  .tabs {
    text-align: left;
    margin-top: 30px;

    .zhuanye_name {
      position: relative;
    }

    .active {
      border-bottom: none !important;
      color: $color;
      height: 41px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      position: relative;
    }

    .active::after {
      content: "";
      display: block;
      width: 100%;
      height: 3px;
      background: #fff;
      position: absolute;
      left: 0;
      bottom: -2px;
    }

    span {
      display: inline-block;
      line-height: 40px;
      padding: 0 10px;
      height: 41px;
      border: 1px solid #EEEEEE;
      margin-left: -1px;
      margin-top: -1px;

    }
  }

  .tabchange {
    text-align: left;
    font-size: 20px;

    span {
      display: inline-block;
      width: 100px;
      height: 50px;
      line-height: 50px;
      text-align: center;
    }

    .active {
      border-bottom: 3px solid $color;
      font-size: 24px;
    }
  }

  .content {
    width: 1280px;
    margin: 0px auto;
    overflow: hidden;
  }

  .main1 {
    align-items: flex-start;
  }

  .one {
    justify-content: space-between;
    flex-wrap: nowrap;

    .info1 {
      margin-left: 68px;

      img {
        width: 20px;
        height: 20px;
        margin-top: 16px;
      }
    }

    text-align: left;
    border-bottom: 1px solid #F2F2F2;
    padding-bottom: 37px;
    margin-top: 30px;

    button {
      width: 74px;
      height: 32px;
      background: $color;
      border-radius: 4px;
      border: none;
      font-weight: 400;
      color: #FFFFFF;
      // margin-left: 240px;
    }

    img {
      width: 67px;
      height: 67px;
      border-radius: 50%;
      margin-right: 12px;
    }

    .type {
      margin-top: 22px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;

      span {
        margin-right: 30px;
      }
    }

    .name {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-right: 29px;
      font-weight: bold;
    }

    .address {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }
  }

  .schoolList {
    margin: 40px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/specialty/specialtyList.vue